module.exports = __webpack_public_path__ + "img/easywallet.84ad4308.png";